﻿import { useDispatch, useSelector } from "react-redux";
import {
  selectMappedSourceCatalogs,
  removeMappedSourceCatalog,
  selectIsAddCrossRefOpen,
  selectMappedGridLoaded,
} from "@/features/connections/crossReferenceSlice";
import {
  ShepDataGridPro,
  ShepPagination,
} from "@/components/GenericComponents/ShepComponents";
import { IconButton } from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import React from "react";
import { GridToolbar } from "@mui/x-data-grid";

const MappedCrossReferencesGrid = ({ sourceConnection, targetConnection }) => {
  const dispatch = useDispatch();
  const isAddCrossRef = useSelector(selectIsAddCrossRefOpen);
  const mappedReferences = useSelector(selectMappedSourceCatalogs);
  const mappedGridLoaded = useSelector(selectMappedGridLoaded);
  const columns = React.useMemo(() => [
    {
      field: "CatalogReference",
      headerName: "From", //or sourceConnection name
      flex: 1,
      minWidth: 200,
      minHeight: 80,
      sortable: true,
      valueGetter: (params) => {
        return params.row.CatalogReference;
      },
      renderCell: (params) => (
        <Box>
          <Typography>{params.row.CatalogReference}</Typography>
        </Box>
      ),
      valueFormatter: (params) => {
        return params.value ?? "";
      },
    },
    {
      field: "MappedCatalogReference",
      headerName: "To", //or targetConnection name
      flex: 1,
      minWidth: 200,
      minHeight: 80,
      sortable: true,
      valueGetter: (params) => {
        return params.row.MappedCatalogReference;
      },
      renderCell: (params) => (
        <Box>
          <Typography>{params.row.MappedCatalogReference}</Typography>
        </Box>
      ),
      valueFormatter: (params) => {
        return params.value ?? "";
      },
    },
    {
      field: "action",
      headerName: "",
      minWidth: 50,
      minHeight: 80,
      sortable: true,
      valueGetter: (params) => {
        return params.row.CatalogReference;
      },
      renderCell: (params) => (
        <Box>
          <IconButton onClick={() => RemoveMapping({ row: params.row })}>
            <CloseIcon />
          </IconButton>
        </Box>
      ),
      valueFormatter: (params) => {
        return params.value ?? "";
      },
    },
  ]);

  const RemoveMapping = ({ row }) => {
    dispatch(
      removeMappedSourceCatalog({
        sourceId: row.CatalogId,
        targetId: row.MappedCatalogId,
      })
    );
  };
  return (
    <>
      <Box
        sx={{
          height: "78px",
          backgroundColor: "var(--primary-main)",
          color: "var(--default-light)",
          padding: "20px 0px 20px 53px",
          marginTop: "42px",
          borderRadius: "4px",
          border: "1px black",
          boxSizing: "border-box",
          width: "90%",
        }}
      >
        <Typography
          style={{
            fontSize: "var(--font-lg)",
            fontWeight: "var(--font-semi-bold)",
          }}
        >
          {isAddCrossRef
            ? "Pending Changes"
            : "Mapped Catalogs and Pending Changes"}
        </Typography>
      </Box>
      <ShepDataGridPro
        isDataLoaded={mappedGridLoaded}
        rows={mappedReferences ?? []}
        columns={columns}
        columnHeaderHeight={78}
        getRowId={(row) => row.CatalogId}
        rowHeight={80}
        pagination
        slots={{
          pagination: () => ShepPagination({ pageOptions: [5] }),
          toolbar: GridToolbar,
        }}
        slotProps={{
          toolbar: {
            printOptions: { disableToolbarButton: true },
            csvOptions: { disableToolbarButton: true },
          },
        }}
        disableColumnMenu
        disableColumnFilter
        disableColumnSelector
        disableDensitySelector
        hideFooterSelectedRowCount
        initialState={{
          pagination: {
            paginationModel: { pageSize: 5, page: 0 },
          },
        }}
        sx={{
          width: "90%",
          maxHeight: "600px",
          "& .MuiDataGrid-virtualScroller": {
            overflow: "hidden",
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            fontSize: "var(--font-md)",
            fontWeight: "var(--font-bold)",
            borderLeft: "none",
          },
          "& .MuiDataGrid-columnHeaders, & .MuiDataGrid-columnHeader:hover": {
            borderBottomLeftRadius: "4px",
            borderBottomRightRadius: "4px",
            backgroundColor: "var(--primary-pale)",
            borderBottom: "none",
            borderLeft: "none",
            paddingLeft: "40px",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
            paddingLeft: "50px",
          },
        }}
      />
    </>
  );
};

export default MappedCrossReferencesGrid;
